import styled from "styled-components"
import { Label, FormGroup } from "client/components"

export const After = styled.span`
    font-size: 14px;
    color: grey;

    ${Label} > & {
        text-transform: none;
        font-size: 13px;
        color: grey;
    }
`
export const FormGroupStyled = styled(FormGroup)<{
    tableView: boolean
}>`
    margin: 0;

    & > * {
        margin-right: unset;
    }

    & > Label {
        margin-right: 10px;
    }

    ${(props) => props.tableView && `
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    `}
`
